import styled from 'foundations-theming/utils';
import UIRouterLink from 'ui-addon-react-router-dom/UIRouterLink';
import { Link as TrellisLink } from 'foundations-components/transitional/components/Link';

/**
 * A component that looks like a link but is in fact not
 * This should be used in the context of a containing component which
 * is actually a link. Do not use this component in place of a real link!
 */
import { jsx as _jsx } from "react/jsx-runtime";
export const LikeLink = styled.span.withConfig({
  displayName: "AcademyLinks__LikeLink",
  componentId: "s63d5u-0"
})(["color:", ";cursor:pointer;font-weight:500;transition:all 0.15s ease-out;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;&:hover{text-decoration:underline;color:", ";}"], ({
  theme,
  color
}) => color || theme.color['text-interactive-default'], ({
  theme,
  hoverColor
}) => hoverColor || theme.color['text-interactive-default-hover']);
export const RouterLink = styled(UIRouterLink).withConfig({
  displayName: "AcademyLinks__RouterLink",
  componentId: "s63d5u-1"
})(["font-weight:500;"]);
const StyledTrellisLink = styled.span.withConfig({
  displayName: "AcademyLinks__StyledTrellisLink",
  componentId: "s63d5u-2"
})(["*{font-weight:500 !important;}"]);
export const Link = props => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledTrellisLink, {
      children: /*#__PURE__*/_jsx(TrellisLink, Object.assign({}, props))
    })
  );
};